import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Theme from '../../../utils/Theme.js';
var theme = Theme.select({
  redbrand: 'redbrand',
  mands: 'mands'
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement(React.Fragment, null, theme === 'redbrand' && React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), React.createElement("path", {
    d: "M16.5 3.5H13V2c0-.825-.675-1.5-1.5-1.5h-5C5.675.5 5 1.175 5 2v1.5H1.5C.675 3.5 0 4.175 0 5v11c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V5c0-.825-.675-1.5-1.5-1.5zm-2.7 6.8h-2.6V6.964l1.3-1.3 1.3 1.3V10.3zM10 6.467V11.5h3.8v4.8H5.2V4.7h6.567L10 6.467zM6.2 2c0-.163.137-.3.3-.3h5c.163 0 .3.137.3.3v1.5H6.2V2zm-5 14V5c0-.163.137-.3.3-.3H4v11.6H1.5a.304.304 0 0 1-.3-.3zm15.6 0c0 .163-.137.3-.3.3H15V6.467L13.233 4.7H16.5c.163 0 .3.137.3.3v11z"
  })), theme === 'mands' && React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), React.createElement("path", {
    d: "M4.086 3.816H2.003A2.01 2.01 0 0 0 0 5.818v7.802a2.008 2.008 0 0 0 2.003 2.002h.627a.475.475 0 0 0 .465.57h.527a.467.467 0 0 0 .464-.474V3.816zM16.023 3.816h-1.746v11.902a.468.468 0 0 0 .465.475h.527a.476.476 0 0 0 .464-.571h.29a2.008 2.008 0 0 0 2.002-2.002V5.818a2.008 2.008 0 0 0-2.002-2.002M12.037 3.816v-.944a.873.873 0 0 0-.872-.87H6.714a.872.872 0 0 0-.872.873v.941H4.733v11.805h8.895V3.816h-1.59zM6.49 2.872a.226.226 0 0 1 .225-.223h4.45a.229.229 0 0 1 .226.226v.941H6.49v-.944z"
  })));
};

export default SvgComponent;